import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSpotlightHeaderInflatorContainer]',
  standalone: false
})
export class SpotlightHeaderInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
